<template>
  <div>
    <div class="search-result-tab">
      <a href="#" :class="currentTagSearchResultTab === 'all' ? 'select' : ''" @click.prevent="()=>changeTagTab('all')">
        <span>전체</span>
      </a>
      <a href="#" :class="currentTagSearchResultTab === 'program' ? 'select' : ''" @click.prevent="()=>changeTagTab('program')">
        <span>프로그램</span>
      </a>
      <a href="#" :class="currentTagSearchResultTab === 'vod'? 'select' : ''" @click.prevent="()=>changeTagTab('vod')">
        <span>에피소드</span>
      </a>
      <a href="#" :class="currentTagSearchResultTab === 'movie'? 'select' : ''" @click.prevent="()=>changeTagTab('movie')">
        <span>영화</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagSearchResultTab',
  props: ['currentTagSearchResultTab', 'changeTagTab']
}
</script>

<style scoped>
  .search-result-tab {
    position: absolute;
    bottom: 0;
    display: inline;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    color: #a5a5a5;
    font-size: 0;
  }
  .search-result-tab a {
    display: inline-block;
    width: 25%;
    box-sizing: border-box;
    text-align: center;
  }
  .search-result-tab a span{
    display: inline-block;
    height: 40px;
    padding: 0 8px;
    border-bottom: 4px transparent solid;
    font-size: 16px;
    line-height: 40px;
    color: #a5a5a5;
  }
  .search-result-tab a.select span{
    border-bottom: 4px #1351f9 solid;
    color: #fff;
    font-weight: 700;
  }
  @media all and (max-width:320px){
    .search-result-tab a {
      font-size: 14px;
    }
  }
</style>
